import queryString from 'query-string';

export const getRootTimesheetLink = () => {
  /* This is duplicated in the routes in app.js */
  return '/submissions/timesheets';
};

export const getTimesheetUrlParamLink = (userId, formattedDate, timeEntryDate, showTerminated) => {
  const newTimeEntryDate = (timeEntryDate) || formattedDate;
  return (
    queryString.stringify({
      userId,
      originDate: formattedDate,
      timeEntryDate: newTimeEntryDate,
      showTerminated,
    }, { sort: false, skipNull: true, skipEmptyString: true })
  );
};

export const getUserTimesheetLink = (userId, originDate) => {
  const formattedDate = originDate.format('YYYY-MM-DD');
  const rootLink = getRootTimesheetLink();

  const paramUrl = getTimesheetUrlParamLink(userId, formattedDate, '', true);
  return `${rootLink}?${paramUrl}`;
};
